// extracted by mini-css-extract-plugin
module.exports = {"thumbnail":"styles_thumbnail__2_CX8"};